<template>
    <div class="rowrapper" :style="{'background-image': 'url(' + require('../../assets/img/zbg.jpg') + ')', 'background-size': 'auto', 'background-position': 'center bottom',  'background-repeat': 'no-repeat'}">
      <div class="div1 colwrapper">
        <div class="div3" style="height: 25%; padding: 2rem">
          <a href="https://zingerwallet.com" target="__blank">
            <img alt="Zinger" src="../../assets/img/logos/zingerlong.png" height="80" width="140">
          </a>
        </div>
        <div class="div4" style="height: 75%; padding: 2rem" v-if="canVerify == 'true'">
          <h3 class="bold-font" style="color: #ffffff;">Verify Your Account</h3>
          <h5 class="bold-font" style="color: #ABEBC6;">Get Started With Zinger</h5>
        </div>
      </div>
      <div class="div2 colwrapper">
        <div class="div3" style="height: 25%;"></div>
        <div class="div4" style="height: 75%;">
          <h3 style="color: #ffffff;" v-if="canVerify == 'false'">Verification Limit Reached</h3>
          <h5 v-if="canVerify == 'false'">Kindly try again in a while</h5>
          <!-- <div class="page"> -->
            <form class="page" @submit.prevent="sendText" v-if="phonePut && canVerify == 'true'">
              <div>
                <h6 style="width: 10%; float:left; padding-top: 1rem; color: #AAB7B8">+234</h6>
                <label class="field field_v1" style="width: 90%; float:right;">
                  <input class="field__input" type="tel" placeholder="e.g. 8012345678" v-model="phone" 
                  pattern="[0-9]{10}" required @input="checkInput">
                  <span class="field__label-wrap">
                    <span class="field__label">Phone Number</span>
                  </span>
                </label>
              </div>
              
              <Button class="w-50 px-4 py-2 bg-green-normal text-white hover:bg-green-light" round
              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                <span style="text-align: center;" v-if="!isLoading">Verify</span>
                <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoading">
              </Button> 
            </form>
            <form class="page" @submit.prevent="verifyCode" v-if="!phonePut && canVerify == 'true'">
              <label class="field field_v1">
                <input class="field__input" type="text" placeholder="e.g. 0000" v-model="code" required @input="checkCodeInput">
                <span class="field__label-wrap">
                  <span class="field__label">Enter Code</span>
                </span>
              </label>
              
              <Button class="w-50 px-4 py-2 bg-green-normal text-white hover:bg-green-light" round
              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                <span style="text-align: center;" v-if="!isLoading">Verify</span>
                <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoading">
              </Button> 
              <div style="padding-left: 1rem; padding-right: 1rem;" :style="!canSeeBtn ? 'text-align: center;' : ''" v-if="canVerify == 'true'">
                <h6 id="ahov" style="margin: auto; color: #2ECC71;" v-if="!canSeeBtn">Resend in {{ seeTime }}s</h6>
                <a href="javascript:void(0)" id="ahov" @click="resendText()" v-if="canSeeBtn">Resend Via Text</a> 
                <a href="javascript:void(0)" id="ahov2" style="float: right;" @click="resendEmail()" v-if="canSeeBtn">Resend Via Email</a> 
              </div> 
            </form>
          <!-- </div> -->
          <div style="padding-right: 1rem; padding-top: 5rem;">
            <a href="https://zingerwallet.com/terms" target="__blank" id="ahov" style="float: right; color: #82E0AA; font-weight: 300; margin-left: 0.5rem;">Terms</a> 
            <a href="https://zingerwallet.com/privacy" target="__blank" id="ahov2" style="float: right; color: #82E0AA; font-weight: 300;">Privacy <span style="margin-left: 0.3rem;">|</span></a> 
          </div> 
        </div>
      </div>

      <modal name="setPinVModal" :clickToClose="false" :adaptive="true" width="520" height="520" :styles="{'border-radius': '20px'}">
        <button @click="$modal.hide('pinBModal')" style="float: right; padding: 1rem;">
          ❌
        </button>
        <div class="tvv2">
          <div>
            <img src="../../assets/img/icons/lock.svg" alt="" class="qrClass">
            <h3 class="bold-font" style="color: #0E6655; font-size: 25px; padding-top: .5rem;">Set Zinger PIN</h3>
            <h4 style="padding-top: .2rem;">Enter a 4-digit PIN</h4>
            <form class="page2" @submit.prevent="setPin">
              <div class="qrClass" style="padding-top: .2rem;">
                <PincodeInput
                  v-model="pinCode1"
                  placeholder="0"
                  :secure="true"
                />
              </div>

              <h4>Re-enter 4-digit PIN</h4>

              <div class="qrClass">
                <PincodeInput
                  v-model="pinCode2"
                  placeholder="0"
                  :secure="true"
                />
              </div>

              <Button class="w-50 px-4 py-2 bg-green-normal text-white hover:bg-green-light" rounded
              :disabled="isDisabled" :buttonType="buttonType" style="display: flex; justify-content: center; align-items: center;">
                <span style="text-align: center; font-weight: 800;" v-if="!isLoadingSetPin">Proceed</span>
                <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoadingSetPin">
              </Button> 
            </form>
          </div>
        </div>
      </modal>
    </div>
</template>

<script>
import router from "../../router";
import Button from "../../components/Button";
// import axios from "axios";
import axios from '../../AxiosInstance.js';
import PincodeInput from 'vue-pincode-input';

  export default {
    name: 'verify',
    components: {
      Button,
      PincodeInput
    },
    data() {
      return{
        url: process.env.VUE_APP_BASE_URL,
        nodeurl: process.env.VUE_APP_NODE_URL,
        isLoading: false,
        isDisabled: true,
        phonePut: true,
        canSeeBtn: false,
        initialTime: 60,
        seeTime: 60,
        logoutTime: 5,
        verify: {},
        code: null,
        v_code: null,
        verifyCount: 0,
        canVerify: localStorage.getItem("can_verify"),
        profile_id: this.decrypt(localStorage.getItem("profile_id")),
        token:this.decrypt(localStorage.getItem("token")),
        phone: '',
        password: '',
        buttonType: 'submit',
        inputType: 'password',
        pinCode1: '',
        pinCode2: '',
        isLoadingSetPin: false,
      }
    },
    created() {
      document.title = "Zinger - Verify Account";
    },
    mounted() {
      this.checkLoggedIn();
    },
    methods: {
      sendText(){
          let self = this;
          this.isLoading = true;
          this.verify.body = Math.floor(100000 + Math.random() * 900000);
          let text = {
              message: this.verify.body,
              to: '234' + this.phone
          }
          let ver = {};
          ver.code = this.verify.body.toString();
          this.v_code = this.verify.body;
          let updated_profile = {};
          updated_profile.phone_number = '+234' + this.phone;

          axios.put(this.url + "api/v1/profile/" + this.profile_id + "/", updated_profile,
          { headers: { authorization: "Token " + this.token } }).then(response2 => {
              axios.post(this.nodeurl + "send-message", text).then(message => {
                // console.log(message)
                axios.put(this.url + "api/v1/verification/" + self.decrypt(localStorage.getItem("verify_id")) + "/", ver,
                { headers: { authorization: "Token " + this.token } }).then(response => {
                    // console.log(response2);
                    this.isLoading = false;
                    this.phonePut = false;
                    // console.log(this.phonePut)
                    this.verifyCount = this.verifyCount + 1;
                    this.countDownTimer();
                    this.$toast.default('A verification code was sent to your phone.', {duration: 5000, position: "top-right"});
                }).catch(err => {
                    // console.log(err);
                    this.isLoading = false;
                    this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
                });
              }).catch(err => {
                  // console.log(err);
                  this.isLoading = false;
                  this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
              });
          }).catch(err => {
              // console.log(err.response.data.phone_number[0]);
              if(err.response){
                if(err.response.data.phone_number[0]){
                  this.$toast.error('A user with that number already exists.', {duration: 3000, position: "top-right"});
                }else{
                  this.$toast.error('Error. Please check your connection.', {duration: 3000});
                }
              }else{
                this.$toast.error('Error. Please check your connection.', {duration: 3000});
              }
              this.isLoading = false;
          });
      },
      setPin(){
        if(this.pinCode1 == this.pinCode2){
          this.isLoadingSetPin = true;
          this.isDisabled = true;

          let updated_profile = {};
          updated_profile.pin = this.pinCode1; 

          axios.put(this.url + "api/v1/profile/" + this.profile_id + "/", updated_profile,
          { headers: { authorization: "Token " + this.token } }).then(response => {
              this.$toast.success('Successfully Set PIN.', {duration: 5000, position: "top-right"});
              this.$modal.hide('setPinVModal');
              localStorage.setItem("has_pin", self.encrypt("true"));
              router.push("/");
          }).catch(err => {
              // console.log(err);
              this.isLoading = false;
              this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
          });
        }else{
          this.$toast.error('Error. Please ensure the codes are the same.', {duration: 3000, position: "top-right"});
        }
      },
      verifyCode(){
        this.isLoading = true;
        let verify = {};
        verify.verified = true;
        let self = this;
        if(this.code.toString() == this.v_code){
            axios.put(this.url + "api/v1/verification/" + self.decrypt(localStorage.getItem("verify_id")) + "/", verify,
            { headers: { authorization: "Token " + this.token } }).then(response => {
                localStorage.setItem("verified_status", self.encrypt("true"));
                this.isLoading = false;
                localStorage.setItem("phone", '234' + this.phone);
                this.$toast.default('Verification Successful.', {duration: 3000, position: "top-right"});
                router.push("/");
            }).catch(err => {
                this.isLoading = false;
                this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"})
            });
        }else{
            this.isLoading = false;
            this.$toast.error('Wrong Code. Please check the code and try again.', {duration: 3000, position: "top-right"})
        }
      },
      resendText(){
        if(this.verifyCount >= 5){
          this.canVerify = 'false';
          localStorage.setItem("can_verify", 'false');
          let updated_profile = {};
          updated_profile.canVerify = false;
          updated_profile.verCanDate = new Date().toISOString();
          axios.put(this.url + "api/v1/profile/" + this.profile_id + "/", updated_profile,
          { headers: { authorization: "Token " + this.token } }).then(response => {
            this.countDownTimerLogout();
          })
        }else{
	  this.v_code = Math.floor(100000 + Math.random() * 900000);
          let text = {
            message: this.v_code,
            to: '234' + this.phone
          }
          this.canSeeBtn = false;
          axios.post(this.nodeurl + "send-message", text).then(message => {
            this.verifyCount = this.verifyCount + 1;
            //this.canSeeBtn = false;
            this.countDownTimer();
            this.$toast.default('Text Resent.', {duration: 3000, position: "top-right"})
          }).catch(err => {
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"})
          });
        }
      },
      resendEmail(){
        if(this.verifyCount >= 5){
          this.canVerify = 'false';
          localStorage.setItem("can_verify", 'false');
          let updated_profile = {};
          updated_profile.canVerify = false;
          updated_profile.verCanDate = new Date().toISOString();
          axios.put(this.url + "api/v1/profile/" + this.profile_id + "/", updated_profile,
          { headers: { authorization: "Token " + this.token } }).then(response => {
            this.countDownTimerLogout();
          })
        }else{
	  this.v_code = Math.floor(100000 + Math.random() * 900000);
          let email = {
            message: this.v_code,
            to: localStorage.getItem("email")
          }
          this.canSeeBtn = false;
          axios.post(this.url + "api/v1/send-verification-email/", email,
          { headers: { authorization: "Token " + this.token } }).then(response => {
            this.verifyCount = this.verifyCount + 1;
            
            this.countDownTimer();
            this.$toast.default('An email has been sent to you.', {duration: 3000, position: "top-right"})
          }).catch(err => {
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"})
          });
        }
      },
      countDownTimer() {
        if(this.seeTime > 0) {
          setTimeout(() => {
            this.seeTime -= 1
            this.countDownTimer()
          }, 1000)
        }else{
          this.canSeeBtn = true;
          this.seeTime = this.initialTime * 2;
          this.initialTime = this.seeTime;
        }
      },
      checkInput(){
        if(this.phone.length < 10){
          this.isDisabled = true
        }else{
          this.isDisabled = false;
        }
      },
      checkCodeInput(){
        if(this.code.length < 10){
          this.isDisabled = true
        }else{
          this.isDisabled = false;
        }
      },
      countDownTimerLogout() {
        if(this.logoutTime > 0) {
          setTimeout(() => {
            this.logoutTime -= 1
            this.countDownTimerLogout()
          }, 1000)
        }else{
          localStorage.removeItem("token");
          this.checkLoggedIn(); 
        }
      },
      checkLoggedIn() {
        let self = this;
        if (!this.token) {
          router.push("/login");
        }else if(self.decrypt(localStorage.getItem("verified_status")) == 'true'){
          router.push("/");
        }
        if(this.canVerify == 'false'){
          let then = localStorage.getItem("ver_can_date");
          then = new Date(then);
          let now = new Date();
          let Difference_In_Time = now.getTime() - then.getTime(); 
          let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24); 
          // console.log(Difference_In_Days)
          if(Difference_In_Days < 1){
            this.canVerify = 'false';
            this.countDownTimerLogout();
          }else{
            this.canVerify = 'true';
            let updated_profile = {};
            updated_profile.canVerify = true;
            updated_profile.verCanDate = null;
            axios.put(this.url + "api/v1/profile/" + this.profile_id + "/", updated_profile,
            { headers: { authorization: "Token " + this.token } }).then(response => {})
          }
        }
      },
    }
  }
</script>

<style lang="css" scoped>

.rowrapper{
  display: flex;
  flex-flow: row wrap;
  justify-content: space-evenly;
  align-content: stretch;
  padding: 0 100px; 
  padding-top: 80px;
  background: #2ECC71;
}

.div1 {
  width: 100%;
  flex: 1 1 25rem;
}

.div2 {
  width: 100%;
  flex: 1 1 25rem;
}

.div3 {
  width: 100%;
  flex: 1 1 25rem;
}

.div4 {
  width: 100%;
  flex: 1 1 25rem;
}

h1, h2, h3, h4, h5, h6 {
    letter-spacing: -.5px;
    line-height: 1.4;
    margin: 5px 0;
    font-weight: 600;
    font-family: "CW BR Firma",sans-serif;
}

a{
  font-weight: 600;
  font-family: "CW BR Firma",sans-serif;
  color: #2ECC71;
}

#ahov:hover{
  color: #ABEBC6;
}

#ahov2:hover{
  color: #ABEBC6;
}

.bold-font{
  font-weight: 700;
}

h3 {
  font-size: 3rem;
}

h5 {
  font-size: 1.56rem;
}

@media screen and (max-width: 1024px){
  h3 {
    font-size: 1.98rem;
  }
  h5 {
    font-size: 1.4rem;
  }
}

@media screen and (max-width: 600px){
  .rowrapper {
      padding: 20px 20px 80px;
  }
}

.field__input{ 
  --uiFieldPlaceholderColor: var(--fieldPlaceholderColor, #767676);
  color: #ffffff;
  
  background-color: transparent;
  border-radius: 0;
  border: none;

  -webkit-appearance: none;
  -moz-appearance: none;

  font-family: inherit;
  font-size: inherit;
}

.field__input:focus::-webkit-input-placeholder{
  color: var(--uiFieldPlaceholderColor);
}

.field__input:focus::-moz-placeholder{
  color: var(--uiFieldPlaceholderColor);
}

/*
=====
CORE STYLES
=====
*/

.field{
  --uiFieldBorderWidth: var(--fieldBorderWidth, 2px);
  --uiFieldPaddingRight: var(--fieldPaddingRight, 1rem);
  --uiFieldPaddingLeft: var(--fieldPaddingLeft, 1rem);   
  --uiFieldBorderColorActive: var(--fieldBorderColorActive, rgba(22, 22, 22, 1));

  display: var(--fieldDisplay, inline-flex);
  position: relative;
  font-size: var(--fieldFontSize, 1rem);
}

.field__input{
  box-sizing: border-box;
  width: var(--fieldWidth, 100%);
  height: var(--fieldHeight, 3rem);
  padding: var(--fieldPaddingTop, 1.25rem) var(--uiFieldPaddingRight) var(--fieldPaddingBottom, .5rem) var(--uiFieldPaddingLeft);
  border-bottom: var(--uiFieldBorderWidth) solid var(--fieldBorderColor, rgba(0, 0, 0, .25));  
}

.field__input:focus{
  outline: none;
}

.field__input::-webkit-input-placeholder{
  opacity: 0;
  transition: opacity .2s ease-out;
}

.field__input::-moz-placeholder{
  opacity: 0;
  transition: opacity .2s ease-out;
}

.field__input:focus::-webkit-input-placeholder{
  opacity: 1;
  transition-delay: .2s;
}

.field__input:focus::-moz-placeholder{
  opacity: 1;
  transition-delay: .2s;
}

.field__label-wrap{
  box-sizing: border-box;
  pointer-events: none;
  cursor: text;
  color: #ffffff;

  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.field__label-wrap::after{
  content: "";
  box-sizing: border-box;
  width: 100%;
  height: 0;
  opacity: 0;

  position: absolute;
  bottom: 0;
  left: 0;
}

.field__input:focus ~ .field__label-wrap::after{
  opacity: 1;
}

.field__label{
  position: absolute;
  left: var(--uiFieldPaddingLeft);
  top: calc(50% - .5em);

  line-height: 1;
  font-size: var(--fieldHintFontSize, inherit);

  transition: top .2s cubic-bezier(0.9, -0.15, 0.1, 1.15), opacity .2s ease-out, font-size .2s ease-out;
  will-change: bottom, opacity, font-size;
}

.field__input:focus ~ .field__label-wrap .field__label,
.field__input:not(:placeholder-shown) ~ .field__label-wrap .field__label{
  --fieldHintFontSize: var(--fieldHintFontSizeFocused, .75rem);

  top: var(--fieldHintTopHover, .25rem);
}

/* 
effect 1
*/

.field_v1 .field__label-wrap::after{
  border-bottom: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  transition: opacity .2s ease-out;
  will-change: opacity;
}

/* 
effect 2
*/

.field_v2 .field__label-wrap{
  overflow: hidden;
}

.field_v2 .field__label-wrap::after{
  border-bottom: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  transform: translate3d(-105%, 0, 0);
  will-change: transform, opacity;
  transition: transform .285s ease-out .2s, opacity .2s ease-out .2s;
}

.field_v2 .field__input:focus ~ .field__label-wrap::after{
  transform: translate3d(0, 0, 0);
  transition-delay: 0;
}

/*
effect 3
*/

.field_v3 .field__label-wrap::after{
  border: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  will-change: opacity, height;
  transition: height .2s ease-out, opacity .2s ease-out;
}

.field_v3 .field__input:focus ~ .field__label-wrap::after{
  height: 100%;
}

/*
=====
LEVEL 4. SETTINGS
=====
*/

.field{
  --fieldBorderColor: #ABEBC6;
  --fieldBorderColorActive: #239B56;
}

/*
=====
DEMO
=====
*/

.page{
  box-sizing: border-box;
  background: #000000; 
  padding: 2rem;
  box-shadow:
  0 2.8px 2.2px rgba(0, 0, 0, 0.034),
  0 6.7px 5.3px rgba(0, 0, 0, 0.048),
  0 12.5px 10px rgba(0, 0, 0, 0.06),
  0 22.3px 17.9px rgba(0, 0, 0, 0.072),
  0 41.8px 33.4px rgba(0, 0, 0, 0.086),
  0 100px 80px rgba(0, 0, 0, 0.12)
  ;
  border-radius: 10px;
  width: 100%;
  max-width: 600px;
  margin: auto;
  /* padding: 1rem; */

  display: grid;
  grid-gap: 30px;
}

.page2{
  background: transparent; 
  padding-left: 2rem;
  padding-right: 2rem;
  width: 100%;
  display: grid;
  grid-gap: 10px;
}

.tvv2{
  /* padding-top: 3rem; */
  text-align: center; 
  height: 100%; 
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 100px;
  scroll-behavior: smooth;  
}

.qrClass{
  display: flex;
  align-items: center; 
  flex-direction: column;
  margin: 0 auto;
}
</style>
